import { Box, IconButton, Stack, useTheme } from '@mui/material'
import ComboBox from '../../../Components/ComboBox'
import React, { useEffect, useState } from 'react'
import InsertChartIcon from '@mui/icons-material/InsertChart'
import TableChartIcon from '@mui/icons-material/TableChart'
import BarChartIcon from '@mui/icons-material/BarChart'
import ReorderIcon from '@mui/icons-material/Reorder'
import Chart1 from './Chart1'
import ListOperations from './ListOperations'

import { Dropdown } from '@mui/base/Dropdown'
import { Menu } from '@mui/base/Menu'
import { MenuButton as BaseMenuButton } from '@mui/base/MenuButton'
import { MenuItem as BaseMenuItem, menuItemClasses } from '@mui/base/MenuItem'
import { bgcolor, borderRadius, styled, useMediaQuery } from '@mui/system'
import Chart2 from './Chart2'
import Chart3 from './Chart3'
import urls from 'utils/urls'
import { makeGetRequest } from 'utils/api'
import { bgBG } from '@mui/material/locale'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function SousCategories() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { t } = useTranslation('layout') // LAP-733 (GE022)

  const [operations, setOperations] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [chartUpdate, setChartUpdate] = useState(0)
  const [chartval, setChartVal] = useState(1)
  const [chartTypeVal, setChartTypeVal] = useState(1)
  const [classification, setClassification] = useState([])
  const [classificationSelected, setClassificationSelected] = useState({})

  useEffect(() => {
    fetchCategoryFi()
  }, [])
  const fetchOperations = async (pagination = '') => {
    let url = `${urls.crudBudgetSousCategoriesOpertations}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setChartUpdate(chartUpdate + 1)
    }
  }
  const fetchCategoryFi = async () => {
    const url = urls.fetchCategories + '?limit=100000&cls=true'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      let ccheck = []
      let classifcation_list = []
      data.forEach((v) => {
        if (!ccheck.includes(v.Classification)) {
          ccheck.push(v.Classification)
          classifcation_list.push({ label: v.Classification, id: v.id })
        }
      })
      // console.log(classifcation_list)
      setClassification(classifcation_list)
      setClassificationSelected(classifcation_list[0])
      fetchOperations('?Classification=' + classifcation_list[0].label)
    }
  }
  const createHandleMenuClick = (menuItem) => {
    return () => {
      setChartTypeVal(menuItem)
    }
  }

  return (
    <div>
      <Box mb={4}>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          flexDirection={isMobile ? 'column' : 'row'}
          spacing={2}
        >
          <ComboBox
            handleAutoComplete={(e, j) => {
              setClassificationSelected(j)
              if (chartval !== 3) fetchOperations('?Classification=' + j.label)
            }}
            sx={{
              width: 350,
              bgcolor: 'white',
              borderRadius: '15px',
              '.MuiAutocomplete-clearIndicator': { display: 'none' },
            }}
            data={classification}
            name="Classification"
            required={true}
            selectedValue={classificationSelected}
          />

          {/* <IconButton>
            <SettingsIcon sx={{ color: 'gray' }} />
          </IconButton>
          <IconButton>
            <AspectRatioIcon sx={{ color: 'gray' }} />
          </IconButton> */}
          <Box>
            <IconButton>
              <Dropdown>
                <MenuButton>
                  <ReorderIcon sx={{ color: 'gray' }} />
                </MenuButton>
                <Menu slots={{ listbox: Listbox }}>
                  <MenuItem onClick={createHandleMenuClick(1)}>{t('finance.monBudget.donutByCategory')}</MenuItem>
                  <MenuItem onClick={createHandleMenuClick(2)}>
                    {t('finance.monBudget.stackedBarByCategory')}
                  </MenuItem>
                  <MenuItem onClick={createHandleMenuClick(3)}>
                    {t('finance.monBudget.stackedBarBySubcategory')}
                  </MenuItem>
                </Menu>
              </Dropdown>
            </IconButton>
            <IconButton onClick={() => setChartVal(1)}>
              <TableChartIcon sx={{ color: 'gray' }} />
            </IconButton>
            <IconButton onClick={() => setChartVal(2)}>
              <InsertChartIcon sx={{ color: 'gray' }} />
            </IconButton>
            <IconButton onClick={() => setChartVal(3)}>
              <BarChartIcon sx={{ color: 'gray' }} />
            </IconButton>
          </Box>
        </Box>
      </Box>
      {chartval === 1 && (
        <>
          <Box display={'flex'} justifyContent={'center'} width={'100%'}>
            {chartTypeVal === 1 && (
              <Chart1
                chartUpdate={chartUpdate}
                classificationSelected={classificationSelected.label}
              />
            )}
            {chartTypeVal === 2 && (
              <Chart2
                chartUpdate={chartUpdate}
                classificationSelected={classificationSelected.label}
              />
            )}
            {chartTypeVal === 3 && (
              <Chart3
                chartUpdate={chartUpdate}
                classificationSelected={classificationSelected.label}
              />
            )}
          </Box>
          <Box mt={3}>
            <ListOperations
              fetchOperations={fetchOperations}
              setSelectedRows={setSelectedRows}
              operations={operations}
              classificationSelected={classificationSelected}
            />
          </Box>
        </>
      )}
      {chartval === 2 && (
        <>
          <Box mt={3}>
            <ListOperations
              fetchOperations={fetchOperations}
              setSelectedRows={setSelectedRows}
              operations={operations}
              classificationSelected={classificationSelected}
            />
          </Box>
        </>
      )}
      {chartval === 3 && (
        <>
          <Box display={'flex'} justifyContent={'center'} width={'100%'}>
            {chartTypeVal === 1 && (
              <Chart1
                chartUpdate={chartUpdate}
                classificationSelected={classificationSelected.label}
              />
            )}
            {chartTypeVal === 2 && (
              <Chart2
                chartUpdate={chartUpdate}
                classificationSelected={classificationSelected.label}
              />
            )}
            {chartTypeVal === 3 && (
              <Chart3
                chartUpdate={chartUpdate}
                classificationSelected={classificationSelected.label}
              />
            )}
          </Box>
        </>
      )}
    </div>
  )
}

const blue = {
  50: '#F0F7FF',
  100: '#C2E0FF',
  200: '#99CCF3',
  300: '#66B2FF',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E6',
  700: '#0059B3',
  800: '#004C99',
  900: '#003A75',
}

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
}

const Listbox = styled('ul')(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  padding: 6px;
  margin: 12px 0;
  min-width: 200px;
  border-radius: 12px;
  overflow: auto;
  outline: 0px;
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  box-shadow: 0px 4px 6px ${
    theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.50)' : 'rgba(0,0,0, 0.05)'
  };
  z-index: 1;
  `,
)

const MenuItem = styled(BaseMenuItem)(
  ({ theme }) => `
  list-style: none;
  padding: 8px;
  border-radius: 8px;
  cursor: default;
  user-select: none;

  &:last-of-type {
    border-bottom: none;
  }

  &.${menuItemClasses.focusVisible} {
    outline: 3px solid ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[100]};
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  }

  &.${menuItemClasses.disabled} {
    color: ${theme.palette.mode === 'dark' ? grey[700] : grey[400]};
  }

  &:hover:not(.${menuItemClasses.disabled}) {
    background-color: ${theme.palette.mode === 'dark' ? blue[900] : blue[50]};
    color: ${theme.palette.mode === 'dark' ? blue[100] : blue[900]};
  }
  `,
)

const MenuButton = styled(BaseMenuButton)(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.5;
  // padding: 8px 16px;
  border-radius: 8px;
  color: white;
  transition: all 150ms ease;
  cursor: pointer;
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);

  &:hover {
    background: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
    border-color: ${theme.palette.mode === 'dark' ? grey[600] : grey[300]};
  }

  &:active {
    background: ${theme.palette.mode === 'dark' ? grey[700] : grey[100]};
  }

  &:focus-visible {
    box-shadow: 0 0 0 4px ${theme.palette.mode === 'dark' ? blue[300] : blue[200]};
    outline: none;
  }
  `,
)
